var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{attrs:{"title":"Upload Image"}},[_c('image-manager',{ref:"profilePicManager",on:{"upload":_vm.uploadProfilePicture}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }